<dx-toolbar class="cc-layout-toolbar">
    <dxi-item location="before" *ngIf="menuToggleEnabled">
        <div *dxTemplate>
            <dx-button
                icon="menu"
                stylingMode="icon"
                hint="Hide Menu"
                class="cc-side-nav-menu-open header-menu-button cc-dummy-button"
                [ngClass]="{ 'header-menu-button-sm': isSmallScreen }"
                (onClick)="toggleMenu()"
            ></dx-button>
        </div>
    </dxi-item>

    <dxi-item [location]="logoLocation" *ngIf="!isSmallScreen">
        <div *dxTemplate="let data of 'item'">
            <app-branding-image></app-branding-image>
        </div>
    </dxi-item>

    <dxi-item location="center" *ngIf="selectedContext">
        <div *dxTemplate>
            <i
                *ngIf="!selectedContext.terminatingDate && selectedContext.communityStatus === 'InTransition'"
                class="cc-community-intransition fa-2x"
                [ngClass]="iconTransition"
                aria-hidden="true"
                [title]="getStatus(selectedContext)"
            ></i>
            <i
                *ngIf="selectedContext.communityStatus === 'Terminated'"
                class="cc-community-terminated fa-2x"
                [ngClass]="iconTerminate"
                aria-hidden="true"
                [title]="getStatus(selectedContext)"
            ></i>
            <i
                *ngIf="selectedContext.terminatingDate && selectedContext.communityStatus !== 'Terminated'"
                class="cc-community-terminating fa-2x"
                [ngClass]="iconExclamatory"
                aria-hidden="true"
                [title]="getStatus(selectedContext)"
            ></i>
            <i
                *ngIf="isNotCurrentOwner && isCommunityInProduction && !hasMultipleCommunities"
                id="home-icon-popover"
                class="cc-community-terminated fa-2x"
                [ngClass]="iconHome"
                (mouseenter)="displayPopover('#home-icon-popover', 'left')"
                aria-hidden="true"
            ></i>
            <i
                *ngIf="hasMultipleCommunities"
                id="multiple-communities-icon"
                class="multiple-communities-icon cc-hyperlink dx-theme-accent-as-text-color"
                [ngClass]="iconMultiCommunities"
                aria-hidden="true"
                title="Other Communities"
                (click)="showCommunities = true"
            ></i>
        </div>
    </dxi-item>

    <dxi-item location="center" *ngIf="selectedContext">
        <div *dxTemplate id="context-customer">
            <ng-container *ngIf="selectedContext.customerId">
                <div
                    class="context-summary"
                    [ngClass]="{
                        'context-summary-lg': isLarge,
                        'context-summary-md': isMedium,
                        'context-summary-sm': isSmall
                    }"
                    (mouseenter)="displayPopover('#context-customer', 'right')"
                >
                    {{ selectedContext.propertyAddress }}
                    <span *ngIf="showOwnerName">
                        <br *ngIf="!isLarge" />
                        ({{ selectedContext.ownerName }})
                    </span>
                </div>
                <div
                    *ngIf="!isSmallScreen || !showOwnerName"
                    class="context-summary context-summary-sm"
                    [title]="getStatus(selectedContext)"
                >
                    <strong>
                        {{ selectedContext.communityCode }}
                    </strong>
                    &nbsp;-&nbsp;
                    <span>
                        {{ selectedContext.communityName }}
                    </span>
                </div>
            </ng-container>
            <ng-container *ngIf="!selectedContext.customerId">
                <div
                    class="context-summary"
                    [title]="getStatus(selectedContext)"
                    [ngClass]="{
                        'context-summary-lg': isLarge,
                        'context-summary-md': isMedium,
                        'context-summary-sm': isSmall
                    }"
                >
                    <strong>
                        {{ selectedContext.communityCode }}
                    </strong>
                    &nbsp;-&nbsp;
                    <span>
                        {{ selectedContext.communityName }}
                    </span>
                </div>
            </ng-container>
        </div>
    </dxi-item>

    <!--
    <dxi-item location="after" [visible]="false">
        <div *dxTemplate="let data of 'item'">
            <app-cira-chat></app-cira-chat>
        </div>
    </dxi-item>
    -->

    <dxi-item location="after" [visible]="hasContext && !!selectedContext?.customerId && isInternalUser">
        <div *dxTemplate="let data of 'item'" class="cc-action-button">
            <dx-drop-down-button
                #actionsDropDownButton
                class="action-dropdown-button icon-button-content"
                icon="fas fa-running action-icon"
                hint="Quick links"
                dropDownContentTemplate="dropDownContentTemplate"
                [showArrowIcon]="false"
                [ngClass]="{
                    'action-dropdown-button-classic-nav': hasClassicNavigator
                }"
            >
                <div *dxTemplate="let content of 'dropDownContentTemplate'" class="content-container">
                    <div class="option-menu" *ngFor="let item of actionItems">
                        <dx-button
                            class="dropdown-button-menu dx-menu-item"
                            stylingMode="text"
                            template="template"
                            [text]="item.title"
                            [hint]="item.title"
                            (onClick)="onActionClick(item)"
                        >
                            <div *dxTemplate="let data of 'template'" class="cc-button-template">
                                <span>
                                    {{ data.text }}
                                    <app-security-info
                                        *ngIf="item.isInternal && item.isSpecificRole"
                                        securityIndicator="KEY"
                                        [accessCode]="item.code"
                                    ></app-security-info>
                                    <app-security-info
                                        *ngIf="item.isInternal && !item.isSpecificRole"
                                        securityIndicator="LOCK"
                                        [accessCode]="item.code"
                                    ></app-security-info>
                                </span>
                            </div>
                        </dx-button>
                    </div>
                </div>
            </dx-drop-down-button>
        </div>
    </dxi-item>

    <dxi-item location="after" *ngIf="hasContext && !!selectedContext?.customerId && isInternalUser">
        <div *dxTemplate="let data of 'item'">
            <div
                class="context-log-call-icon fa-stack"
                [ngClass]="{
                    'context-log-call-icon-sm': isSmallScreen,
                    'context-log-call-icon-classic-nav': hasClassicNavigator
                }"
                (click)="showLogAPhoneCall()"
            >
                <i class="fas fa-comment-alt fa-2x fa-stack-1x dx-theme-accent-as-text-color"></i>
                <i class="fas fa-bars fa-stack-1x stack-icon cc-white-icon" title="Log Call / Create Case"></i>
            </div>
        </div>
    </dxi-item>

    <dxi-item location="after" *ngIf="hasContext && isInternalUser" cssClass="context-alert-icon-item">
        <div *dxTemplate="let data of 'item'">
            <i
                class="context-alert-icon dx-theme-accent-as-text-color fas fa-bullhorn"
                title="Alerts"
                [ngClass]="{
                    'context-alert-icon-sm': isSmallScreen,
                    'context-alert-icon-cirabooks': isCiraBooksView,
                    'context-alert-icon-classic-nav': hasClassicNavigator
                }"
                (click)="showContextAlerts()"
            ></i>
        </div>
    </dxi-item>

    <dxi-item *ngIf="!isSmallScreen && !isInternalUser && hasBoardApprovalAccess" location="after">
        <div class="approval-button-content cc-approval-button-content" (click)="onShowBoardApprovalClick()">
            <i class="fas fa-bell approval-button"></i>
            <div *ngIf="baordApprovalOpenItemsCount > 0" class="badge-container">
                <div class="badger-inner-header">
                    <p class="badger-badge-header">{{ baordApprovalOpenItemsCount }}</p>
                </div>
            </div>
        </div>
    </dxi-item>

    <dxi-item *ngIf="!isSmallScreen" location="after">
        <div class="announcement-button-content cc-announcement-button-content" (click)="showPortalAnnouncements()">
            <i class="fa fa-bullhorn announcement-button"></i>
            <div *ngIf="announcementCount > 0" class="badge-container">
                <div class="badger-inner-header">
                    <p class="badger-badge-header">{{ announcementCount }}</p>
                </div>
            </div>
        </div>
    </dxi-item>

    <dxi-item *ngIf="!!sessionEndsIn" location="after">
        <div *dxTemplate>
            <div
                class="token-time-button-content"
                title="Session Ends In: {{ sessionEndsIn[0] }}hr {{ sessionEndsIn[1] }}min"
                [ngClass]="{ 'cc-hyperlink': 2 > sessionEndsIn[0] }"
                (click)="onSessionEndsClick()"
            >
                <i
                    class="fas fa-stopwatch token-time-icon cc-header-title"
                    [ngClass]="{ 'cc-red-background-as-text': 2 > sessionEndsIn[0] }"
                ></i>
                <div class="token-time-text">
                    <span>{{ sessionEndsIn[0] }} hr</span>
                    <span>{{ sessionEndsIn[1] }} min</span>
                </div>
            </div>
        </div>
    </dxi-item>

    <dxi-item location="after">
        <div *dxTemplate="let data of 'item'">
            <dx-button
                class="user-button authorization cc-dummy-button"
                [width]="menuButtonWidth"
                height="100%"
                stylingMode="text"
            >
                <div *dxTemplate="let data of 'content'">
                    <app-user-panel [menuItems]="userMenuItems" menuMode="context"></app-user-panel>
                </div>
            </dx-button>
        </div>
    </dxi-item>

    <div *dxTemplate="let data of 'menuItem'">
        <app-user-panel [menuItems]="userMenuItems" menuMode="list"></app-user-panel>
    </div>
</dx-toolbar>

<app-preferences #preferenceComponent (onClose)="onPreferenceClose($event)"></app-preferences>

<app-community-owner-alerts #contextAlerts></app-community-owner-alerts>

<app-owner-welcome-letter
    *ngIf="displayWelcomeLetter"
    [visible]="displayWelcomeLetter"
    (closeWelcomeLetter)="onWelcomeLetterClose($event)"
></app-owner-welcome-letter>

<app-log-returned-mail
    *ngIf="displayLogReturnedMail"
    [visible]="displayLogReturnedMail"
    (onClose)="onCloseLogReturnedMail()"
></app-log-returned-mail>

<app-portal-announcement
    *ngIf="displayPortalAnnouncements"
    [visible]="displayPortalAnnouncements"
    (onRead)="onReadPortalAnnouncement()"
    (onClose)="onClosePortalAnnouncement()"
></app-portal-announcement>

<app-portal-announcement
    *ngIf="displayResidentAnnouncements"
    [visible]="displayResidentAnnouncements"
    [isResidentAnnouncement]="true"
    (onClose)="onCloseResidentAnnouncement()"
></app-portal-announcement>

<app-manage-qa-users *ngIf="showManageQaUsers" [(visible)]="showManageQaUsers"></app-manage-qa-users>

<cc-message-box #unconveyanceMessageBox></cc-message-box>

<dx-load-panel
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<dx-popup
    *ngIf="showExtendSession"
    title="Renew Session Time"
    [width]="320"
    [height]="172"
    [showTitle]="true"
    [resizeEnabled]="false"
    [(visible)]="showExtendSession"
>
    <div *dxTemplate="let data of 'content'">
        <dx-form width="100%" height="100%" labelLocation="left">
            <dxi-item>
                <dxo-label [visible]="false"></dxo-label>
                <div *dxTemplate>
                    <strong>
                        NOTE: It is recommended to logout and close all your CiraNet browser tabs on a regular basis to
                        get the latest updates.
                    </strong>
                </div>
            </dxi-item>
            <dxi-item [isRequired]="true">
                <dxo-label text="Password"></dxo-label>
                <div *dxTemplate>
                    <dx-text-box
                        placeholder="Password"
                        [(mode)]="passwordMode"
                        [(value)]="userPassword"
                        valueChangeEvent="keyup"
                        (onEnterKey)="doExtendSession(true)"
                    >
                        <dxi-button
                            *ngIf="passwordMode === 'password'"
                            name="password"
                            location="after"
                            [options]="passwordShowButton"
                        ></dxi-button>
                        <dxi-button
                            *ngIf="passwordMode !== 'password'"
                            name="password"
                            location="after"
                            [options]="passwordHideButton"
                        ></dxi-button>
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </dxi-item>
            <dxi-item>
                <div *dxTemplate>
                    <dx-toolbar>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="doExtendSession(false)"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Submit"
                                    hint="Submit"
                                    [icon]="iconSubmit"
                                    [disabled]="!userPassword"
                                    (onClick)="doExtendSession(true)"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-form>
    </div>
</dx-popup>

<dx-popup
    *ngIf="showConveyProperty"
    width="90%"
    height="99%"
    title="Property Conveyance Wizard"
    [(visible)]="showConveyProperty"
    [showTitle]="true"
    [resizeEnabled]="false"
    (onShown)="onPropertyConveyanceShown()"
    (onHidden)="onPropertyConveyanceHide()"
>
    <div *dxTemplate="let data of 'content'">
        <iframe
            *ngIf="showConveyProperty"
            id="conveyFrameElement"
            width="100%"
            height="100%"
            class="cc-iframe"
            title="Property Conveyance Wizard"
            [src]="conveyPropertyUrl | ccSafeUrl"
        ></iframe>
    </div>
</dx-popup>

<dx-popover
    *ngIf="hasMultipleCommunities"
    target="#multiple-communities-icon"
    position="top"
    title="Other Communities"
    [showTitle]="false"
    [minWidth]="300"
    [(visible)]="showCommunities"
>
    <div *dxTemplate="let data of 'content'" class="multiple-communities-popover">
        <ng-container *ngFor="let com of otherCommunities">
            <dx-button
                type="default"
                stylingMode="text"
                [text]="com.displayText"
                [hint]="com.displayText"
                (onClick)="onCommunityClick(com)"
            ></dx-button>
        </ng-container>
    </div>
</dx-popover>

<dx-popover
    *ngIf="showPopover"
    [target]="currentTarget"
    [position]="currentPosition"
    [minWidth]="150"
    [(visible)]="showPopover"
>
    <div
        *dxTemplate="let data of 'content'"
        class="rnumber-content"
        [innerHTML]="getTooltip()"
        (mouseleave)="hidePopover()"
    ></div>
</dx-popover>
